<template>
  <q-page fluid class="row">
    <div style="max-height: calc(100vh - 82px)" class="row full-width">
      <div
        v-show="reportView"
        class="col-12 q-px-sm q-pt-sm"
        :style="`min-height: ${reportView ? '72px' : '400px'};`"
      >
        <scannedSurveys
          ref="scannedSurveysGrid"
          :collapseOnSelect="true"
          @viewReport="loadReport"
          @closeReport="closeReport"
          @selectAnotherScan="selectAnotherScan"
        />
      </div>
      <div
        v-show="!reportView"
        class="col-12 col-md-6 q-px-sm q-pb-sm"
        :style="`height: 100%;`"
      >
        <scannedSurveys
          :collapseOnSelect="true"
          @viewReport="loadReport"
          @closeReport="closeReport"
          @selectAnotherScan="selectAnotherScan"
        />
      </div>
      <div
        v-if="!reportView"
        class="col-12 col-md-6 q-px-sm q-pb-sm"
        style="height: calc(100%)"
      >
        <past-surveys-clustor-map @viewReport="loadReport" />
      </div>
      <div
        v-if="reportView"
        class="col-12 col-md-8 q-px-sm q-pb-sm"
        :style="`height: calc(100% - ${reportView ? '80px' : '400px'})`"
      >
        <survey-map-report
          ref="gmap"
          @closeReport="closeReport"
          @dotClicked="dotClicked"
        />
      </div>
      <div
        v-if="reportView"
        class="col-12 col-md-4 q-px-sm q-pb-sm"
        :style="`height: calc(100% - ${reportView ? '80px' : '400px'})`"
      >
        <survey-data-report
          ref="reportData"
          :id="reportID"
          @panToLocation="gmapPanToLocation"
          @rangeChanged="gmapRangeChanged"
          @toggleGraph="gmapToggleGraph"
          @changeDisplayedMap="changeDisplayedMap"
          @limitsChanged="updateMapLimits"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import { mapGetters } from "vuex";
  import scannedSurveys from "@/components/scheduledSurveys/scannedSurveys.vue";
  import scheduledSurveys from "@/components/scheduledSurveys/scheduledSurveys.vue";
  import pastSurveysClustorMap from "@/components/scheduledSurveys/pastSurveysClustorMap.vue";
  import surveyMapReport from "@/components/surveyReport/surveyMapReport.vue";
  import surveyDataReport from "@/components/surveyReport/surveyDataReport.vue";

  import moment from "moment";

  export default {
    components: {
      scannedSurveys,
      scheduledSurveys,
      pastSurveysClustorMap,
      surveyMapReport,
      surveyDataReport,
    },
    computed: {
      ...mapGetters(["currentUser"]),
    },
    props: {
      source: String,
    },
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    data: () => ({
      reportView: false,
      reportID: null,
    }),
    mounted() {
      this.handleRoute();
    },
    methods: {
      loadReport(survey) {
        // this.reportView = true;
        // this.reportID = survey.id;
        this.$router.push(`/reporting/${survey.id}`);
      },
      handleRoute() {
        if (this.$route.params.report_id) {
          this.$store.dispatch("loadSurveyByID", this.$route.params.report_id);
          this.reportView = true;
        } else {
          this.reportView = false;
          this.reportID = null;
        }
      },
      close() {
        this.$router.push(`/reporting`);
      },
      closeReport() {
        this.$router.push(`/reporting`);
      },
      gmapPanToLocation(pos, point) {
        this.$refs.gmap.updateCenterPOS(pos, point);
      },
      gmapRangeChanged(min, max) {
        this.$refs.gmap.rangeChanged(min, max);
      },
      gmapToggleGraph(value) {
        this.$refs.gmap.toggleGraph(value);
      },
      dotClicked(point) {
        this.$refs.reportData.dotClicked(point);
      },
      selectAnotherScan() {
        this.$refs.reportData.openAddNewScan();
      },
      changeDisplayedMap(index) {
        this.$refs.gmap.changeDisplayedMap(index);
      },
      updateMapLimits(limits) {
        this.$refs.gmap.lowerLimit = limits.lowerLimit;
        this.$refs.gmap.upperLimit = limits.upperLimit;
      },
    },
  };
</script>
